export class UserPermissionsState {
  userPermissions: any[] = [];
}
